





















import Vue, { PropType } from 'vue'
import Media from '@/types/Media.interface'
import MessagePreviewBubble from '@/components/MessagePreviewBubble.vue'
export default Vue.extend({
    components: { MessagePreviewBubble },
    props: {
        //  Determines whether we include company name in our message
        companyToggle: {
            type: Boolean,
            default: false
        },
        //  Determines whether we include consent message in our message
        consentToggle: {
            type: Boolean,
            default: false
        },
        //  The message being shown
        message: {
            type: String,
            required: false
        },
        //  Any Media attached to the message
        media: {
            type: Object as PropType<Media>,
            required: false
        },
        //  Passed from BroadcastForm.vue and tells us if the user wants the company name in the broadcast or not 
        hasCompanyName: {
            type: Boolean,
            default: true
        },
        //  Passed from BroadcastForm.vue and tells us if the user wants the opt-out message in the broadcast or not 
        hasConsent: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        bubbleText(): string {
            //  Grab our message, or default to "Your Message Here" if empty
            let msg = this.message || 'Your Message Here'

            //  If we have the company toggle on and there is no company name in our phone preview then we add the text to the preview, this is becuase this component is separate from our
            //  BroadcastFormCompose.vue and thus we have to have the same logic here to ensure these two components are in-sync
            if (this.companyToggle && !this.hasCompanyName) {
                msg = `${this.companyName}${msg}`
            }
            //  If we have our consent message toggled and don't have opt-out in the message yet we append it
            if (this.consentToggle && !this.hasConsent) {
                msg = `${msg}${this.consentMsg}`
            }
            
            //  In the case the user is editing their message from a schedule or draft broadcast we need the inverse logic of above so that the broadcast preview removes the text if they
            //  turn one of the toggles off
            if (!this.companyToggle && this.hasCompanyName) {
                msg = msg.replace(this.companyName, '')
            }
        
            if (!this.consentToggle && this.hasConsent) {
                msg = msg.replace(this.consentMsg, '')
            }

            //  If message is empty, return 'Your Message Here'
            if (!msg) return 'Your Message Here'

            //  Return our message
            return msg
        },
        companyName(): string {
            //  Grab the current tenant from the store
            const tenant = this.$store.getters.tenant

            //  Get our tenant's organization name
            const orgName = tenant.company_name

            //  Return the orgname with a newline appended
            return `${orgName}\n`
        },
        consentMsg(): string {
            //  Grab our consent from the store
            const consent = this.$store.getters.consent

            //  Grab the opt in message
            const optIn = consent?.opt_in_message

            //  Return the opt in with a newline prepended
            return `\n${optIn}`
        }
    },
    data: () => ({
        textAreaStyling: {
            color: '#424242',
            background: '#EAEAEA',
            border: '1px solid #EAEAEA',
            borderRadius: '10px 10px 10px 10px',
            padding: '15px',
            overflowWrap: 'break-word',
            width: '100%',
            textAlign: 'left'
        }
    })
})
